import {ReactNode, RefObject} from "react";
import {createPortal} from "react-dom";

import {useAnchoredDropdownPosition} from "../../hooks/use_anchored_dropdown_position";
import {SearchDropdown} from "./SearchAutocomplete";
import {SearchAutocompleteDropdownProps} from "./SearchAutocompleteTypes";

interface IProps {
    anchorRef: RefObject<HTMLElement | null>;
    portalRef: RefObject<HTMLDivElement | null>;
    dropdownProps: SearchAutocompleteDropdownProps;
    children: ReactNode;
}

export const SearchAutocompleteDropdownPortal = (props: IProps) => {
    const {anchorRef, portalRef, dropdownProps, children} = props;
    const positionStyle = useAnchoredDropdownPosition({
        anchorRef,
        isActive: dropdownProps.isOpen
    });

    if (!dropdownProps.isOpen || typeof document === "undefined" || !positionStyle) {
        return null;
    }

    return createPortal(
        <SearchDropdown ref={portalRef} {...dropdownProps} isPortaled style={positionStyle}>
            {children}
        </SearchDropdown>,
        document.body
    );
};
import {ReactNode, RefObject} from "react";
import {createPortal} from "react-dom";

import {useAnchoredDropdownPosition} from "../../hooks/use_anchored_dropdown_position";
import {SearchDropdown} from "./SearchAutocomplete";
import {SearchAutocompleteDropdownProps} from "./SearchAutocompleteTypes";

interface IProps {
    anchorRef: RefObject<HTMLElement | null>;
    portalRef: RefObject<HTMLDivElement | null>;
    dropdownProps: SearchAutocompleteDropdownProps;
    children: ReactNode;
}

export const SearchAutocompleteDropdownPortal = (props: IProps) => {
    const {anchorRef, portalRef, dropdownProps, children} = props;
    const positionStyle = useAnchoredDropdownPosition({
        anchorRef,
        isActive: dropdownProps.isOpen
    });

    if (!dropdownProps.isOpen || typeof document === "undefined" || !positionStyle) {
        return null;
    }

    return createPortal(
        <SearchDropdown ref={portalRef} {...dropdownProps} isPortaled style={positionStyle}>
            {children}
        </SearchDropdown>,
        document.body
    );
};
